import React, { useEffect, useState } from "react";
// import { Link } from 'react-router-dom'
import Chart from "react-apexcharts";

//datepicker
import Datepickers from "../../../components/Datepicker";

//circularpro
import "react-circular-progressbar/dist/styles.css";
import { Card, Container, Row, Col, Button, Form } from "react-bootstrap";
import { useDashboardMutation, useGetUserListMutation, useGetSourcesMutation, useGetTotalCreditBalanceMutation } from "../../../api/usersAPISlices";
import CommissionCard from "../../../components/dashboard/CommissionCard";
import LeadDistributionChart from "../../../components/dashboard/LeadDistributionChart";
import RevenueChart from "../../../components/dashboard/RevenueChart";
import UndistributedLeads from "../../../components/dashboard/UndistributedLeads";
import WeeklyDistributionRate from "../../../components/dashboard/WeeklyDistributionRate";
import { formatCurrency, formatNumber } from "../../../utils/formatters";


const Dashbord = () => {
  const [categories, setCategories] = useState([])
  const [leads, setleads] = useState([])
  const [revenueData, setRevenueData] = useState([])
  const [totalRevenue, setTotalRevenue] = useState(0)
  const [distributionRate, setDistributionRate] = useState(0)
  const [startDate, setStartDate] = useState('')
  const [endDate, setEndDate] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const [totalLeads, setTotalLeads] = useState(0)
  const [selectedUser, setSelectedUser] = useState('')
  const [selectedSource, setSelectedSource] = useState('')
  const [users, setUsers] = useState([])
  const [sources, setSources] = useState([])
  const [totalCreditBalance, setTotalCreditBalance] = useState(null)

  const [dashboard] = useDashboardMutation()
  const [getUserList] = useGetUserListMutation()
  const [getSources] = useGetSourcesMutation()
  const [getTotalCreditBalance] = useGetTotalCreditBalanceMutation()

  const token = JSON.parse(localStorage.getItem("token"))
  const user = JSON.parse(localStorage.getItem("user"))

  const chart1 = {
    options: {
      colors: ["#3378FF"],
      chart: {
        fontFamily: "Inter, sans-serif",
        toolbar: {
          show: false,
        },
        sparkline: {
          enabled: false,
        },
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        curve: "smooth",
        width: 3,
      },
      fill: {
        type: "gradient",
        gradient: {
          shade: "light",
          type: "vertical",
          shadeIntensity: 0.5,
          gradientToColors: ["#66a6ff"],
          inverseColors: false,
          opacityFrom: 0.5,
          opacityTo: 0.1,
          stops: [0, 100],
        },
      },
      grid: {
        borderColor: '#f1f1f1',
        strokeDashArray: 4,
        xaxis: {
          lines: {
            show: false,
          },
        },
        yaxis: {
          lines: {
            show: true,
          },
        },
        padding: {
          top: 0,
          right: 0,
          bottom: 0,
          left: 0,
        },
      },
      yaxis: {
        labels: {
          offsetY: 0,
          minWidth: 40,
          style: {
            colors: '#9ca3af',
            fontSize: '12px',
          },
        },
      },
      xaxis: {
        type: "datetime",
        labels: {
          minHeight: 20,
          maxHeight: 20,
          style: {
            colors: '#9ca3af',
            fontSize: '12px',
          },
        },
        axisBorder: {
          show: false,
        },
        axisTicks: {
          show: false,
        },
        categories: categories,
        // [
        //   // "2018-09-1",
        //   "09/2",
        //   "09/3",
        //   "09/4",
        //   "09/5",
        //   "09/6",
        //   "09/7",
        //   "09/8",
        //   "09/9",
        //   "09/10",
        //   "09/11",
        //   "09/12",
        //   "09/13",
        //   "09/14",
        //   "09/15",
        //   "09/16",
        //   "09/17",
        //   "09/18",
        //   "09/19",
        //   "09/20",
        //   "09/21",
        //   "09/22",
        // ],
      },
      tooltip: {
        x: {
          format: "dd/MM/yy HH:mm",
        },
      },
    },
    series: [
      // {
      //   name: "Incomes",
      //   data: [90, 105, 72, 90, 65, 109, 130,90, 105, 72, 90, 65, 109, 130,90, 105, 72, 90, 65, 109, 130],
      // },
      {
        name: "Leads",
        data: leads,
        // [115, 93, 75, 102, 144, 52, 71,115, 93, 75, 102, 144, 52, 71,115, 93, 75, 102, 144, 52, 71],
      },
    ],
  };

  const getLeadReport = async () => {
    setIsLoading(true)

    const payload = {
      start_date: startDate,
      end_date: endDate,
      ...(selectedUser && { user_id: selectedUser }),
      ...(selectedSource && { source_id: selectedSource })
    }

    await dashboard({ payload, token })
      .unwrap()
      .then((res) => {
        setCategories(res?.graph?.[0]?.data)
        setleads(res?.graph?.[1]?.data)
        setRevenueData(res?.graph?.[2]?.data || [])
        setTotalLeads(res?.total)
        setTotalRevenue(res?.totalRevenue || 0)
        setDistributionRate(res?.distributionRate || 0)
        setIsLoading(false)
      })
      .catch((error) => {
        console.log('error', error)
        setIsLoading(false)
      })
  }

  const fetchUsers = async () => {
    try {
      const res = await getUserList({ token, currentPage: 1 }).unwrap()
      setUsers(res?.data || [])
    } catch (error) {
      console.log('Error fetching users:', error)
    }
  }

  const fetchSources = async () => {
    try {
      const res = await getSources({ token }).unwrap()
      setSources(res || [])
    } catch (error) {
      console.log('Error fetching sources:', error)
    }
  }

  const fetchTotalCreditBalance = async () => {
    if (user?.role === 'admin') {
      try {
        const res = await getTotalCreditBalance({ token }).unwrap()
        setTotalCreditBalance(res.total_credit_balance)
      } catch (error) {
        console.log('Error fetching total credit balance:', error)
      }
    }
  }

  // Helper function to format date in California timezone
  const formatDateForCaliforniaTimezone = (date = new Date()) => {
    // Format the date in California timezone
    const options = {
      timeZone: "America/Los_Angeles",
      year: 'numeric',
      month: '2-digit',
      day: '2-digit'
    };

    const formatter = new Intl.DateTimeFormat('en-US', options);
    const parts = formatter.formatToParts(date);

    const dateObj = {};
    parts.forEach(part => {
      if (part.type !== 'literal') {
        dateObj[part.type] = part.value;
      }
    });

    // Return formatted date string in YYYY-MM-DD format
    return `${dateObj.year}-${dateObj.month}-${dateObj.day}`;
  };

  const formatDateLocal = (date) => {
    return formatDateForCaliforniaTimezone(date);
  };

  const byDefulat = () => {
    const today = new Date();

    // Get the first day of the current month in California timezone
    // We need to adjust for timezone by adding a day to ensure we get the right month
    const year = today.getFullYear();
    const month = today.getMonth();

    // Create start of month with noon time to avoid timezone edge cases
    const startOfMonth = new Date(year, month, 1, 12, 0, 0);

    // Set the start and end dates to show this month's data
    setStartDate(formatDateLocal(startOfMonth));
    setEndDate(formatDateLocal(today));
  };

  useEffect(() => {
    byDefulat()
    fetchUsers()
    fetchSources()
    fetchTotalCreditBalance()
  }, [])

  useEffect(() => {
    if (startDate && endDate) {
      getLeadReport()
    }
  }, [startDate, endDate, selectedUser, selectedSource])

  const handleToday = () => {
    const today = new Date();
    setStartDate(formatDateLocal(today));
    setEndDate(formatDateLocal(today));
  };

  const handleYesterday = () => {
    const yesterday = new Date();
    yesterday.setDate(yesterday.getDate() - 1);
    setStartDate(formatDateLocal(yesterday));
    setEndDate(formatDateLocal(yesterday));
  };

  const handleThisWeek = () => {
    const today = new Date();
    const dayOfWeek = today.getDay();
    const startOfWeek = new Date(today);
    // Set to Monday of current week
    startOfWeek.setDate(today.getDate() - (dayOfWeek === 0 ? 6 : dayOfWeek - 1));

    setStartDate(formatDateLocal(startOfWeek));
    setEndDate(formatDateLocal(today));
  };

  const handleThisMonth = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = today.getMonth();

    // Create start of month with noon time to avoid timezone edge cases
    const startOfMonth = new Date(year, month, 1, 12, 0, 0);

    setStartDate(formatDateLocal(startOfMonth));
    setEndDate(formatDateLocal(today));
  };

  const handlePreviousWeek = () => {
    const today = new Date();
    const dayOfWeek = today.getDay();
    const startOfThisWeek = new Date(today);
    startOfThisWeek.setDate(today.getDate() - (dayOfWeek === 0 ? 6 : dayOfWeek - 1));

    const startOfPrevWeek = new Date(startOfThisWeek);
    startOfPrevWeek.setDate(startOfThisWeek.getDate() - 7);

    const endOfPrevWeek = new Date(startOfPrevWeek);
    endOfPrevWeek.setDate(startOfPrevWeek.getDate() + 6);

    setStartDate(formatDateLocal(startOfPrevWeek));
    setEndDate(formatDateLocal(endOfPrevWeek));
  };

  const handlePreviousMonth = () => {
    const today = new Date();
    const startOfPrevMonth = new Date(today.getFullYear(), today.getMonth() - 1, 1);
    const endOfPrevMonth = new Date(today.getFullYear(), today.getMonth(), 0);

    setStartDate(formatDateLocal(startOfPrevMonth));
    setEndDate(formatDateLocal(endOfPrevMonth));
  };

  return (
    <>
      <style>{`
        .hover-lift:hover {
          transform: translateY(-2px);
          box-shadow: 0 10px 20px rgba(0, 0, 0, 0.12), 0 4px 8px rgba(0, 0, 0, 0.06) !important;
        }
        .table-hover tbody tr:hover {
          background-color: rgba(99, 102, 241, 0.04);
        }
      `}</style>
    <Container fluid>
      <Row>
        <Col md="12" className="mb-4 mt-3">
          <Row className="d-flex flex-wrap justify-content-between align-items-center" style={{justifyContent: 'space-between'}}>
            <Col lg="4">
              <h4 className="font-weight-bold">Overview</h4>
            </Col>

            <Col lg="8" className="mt-3 mt-lg-0">
              <div className="d-flex flex-wrap align-items-center justify-content-lg-end" style={{gap: '10px'}}>
                {/* Filter Dropdowns */}
                {(user?.role === 'admin' || user?.role === 'manager') && (
                  <select
                    className="form-control form-control-sm shadow-sm"
                    value={selectedUser}
                    onChange={(e) => setSelectedUser(e.target.value)}
                    style={{
                      borderRadius: '8px',
                      border: '1px solid #e3e6f0',
                      minWidth: '180px',
                      width: 'auto',
                      padding: '0 10px',
                      fontSize: '14px',
                      backgroundColor: '#fff',
                      cursor: 'pointer',
                      transition: 'border-color 0.2s',
                      backgroundImage: `url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%23343a40' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M2 5l6 6 6-6'/%3e%3c/svg%3e")`,
                      backgroundRepeat: 'no-repeat',
                      backgroundPosition: 'right 8px center',
                      backgroundSize: '14px 10px',
                      appearance: 'none',
                      WebkitAppearance: 'none',
                      MozAppearance: 'none'
                    }}
                    onFocus={(e) => e.target.style.borderColor = '#3378FF'}
                    onBlur={(e) => e.target.style.borderColor = '#e3e6f0'}
                  >
                    <option value="">All Users</option>
                    {users.map((user) => (
                      <option key={user.id} value={user.id}>
                        {user.first_name} {user.last_name}
                      </option>
                    ))}
                  </select>
                )}
                
                <select
                  className="form-control form-control-sm shadow-sm"
                  value={selectedSource}
                  onChange={(e) => setSelectedSource(e.target.value)}
                  style={{
                    borderRadius: '8px',
                    border: '1px solid #e3e6f0',
                    minWidth: '180px',
                    width: 'auto',
                    padding: '0 10px',
                    fontSize: '14px',
                    backgroundColor: '#fff',
                    cursor: 'pointer',
                    transition: 'border-color 0.2s',
                    backgroundImage: `url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%23343a40' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M2 5l6 6 6-6'/%3e%3c/svg%3e")`,
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'right 8px center',
                    backgroundSize: '14px 10px',
                    appearance: 'none',
                    WebkitAppearance: 'none',
                    MozAppearance: 'none'
                  }}
                  onFocus={(e) => e.target.style.borderColor = '#3378FF'}
                  onBlur={(e) => e.target.style.borderColor = '#e3e6f0'}
                >
                  <option value="">All Sources</option>
                  {sources.map((source) => (
                    <option key={source.id} value={source.id}>
                      {source.name || `Source ${source.id}`}
                    </option>
                  ))}
                </select>
                
                {/* Date Quick Filters */}
                <div className="d-flex" style={{gap: '8px'}}>
                  <div className="btn-group shadow-sm" role="group">
                    <button
                      type="button"
                      className="btn btn-sm btn-outline-primary"
                      onClick={handleToday}
                      style={{
                        borderRadius: '8px 0 0 8px',
                        padding: '5px 12px',
                        fontSize: '13px',
                        fontWeight: '500',
                        borderColor: '#3378FF',
                        color: '#3378FF'
                      }}
                    >
                      Today
                    </button>
                    <button
                      type="button"
                      className="btn btn-sm btn-outline-primary"
                      onClick={handleYesterday}
                      style={{
                        borderRadius: '0 8px 8px 0',
                        padding: '5px 12px',
                        fontSize: '13px',
                        fontWeight: '500',
                        borderLeft: 'none',
                        borderColor: '#3378FF',
                        color: '#3378FF'
                      }}
                    >
                      Yesterday
                    </button>
                  </div>
                  <div className="btn-group shadow-sm" role="group">
                    <button
                      type="button"
                      className="btn btn-sm btn-outline-primary"
                      onClick={handleThisWeek}
                      style={{
                        borderRadius: '8px 0 0 8px',
                        padding: '5px 12px',
                        fontSize: '13px',
                        fontWeight: '500',
                        borderColor: '#3378FF',
                        color: '#3378FF'
                      }}
                    >
                      This Week
                    </button>
                    <button
                      type="button"
                      className="btn btn-sm btn-outline-primary"
                      onClick={handlePreviousWeek}
                      style={{
                        borderRadius: '0 8px 8px 0',
                        padding: '5px 12px',
                        fontSize: '13px',
                        fontWeight: '500',
                        borderLeft: 'none',
                        borderColor: '#3378FF',
                        color: '#3378FF'
                      }}
                    >
                      Prev Week
                    </button>
                  </div>
                  <div className="btn-group shadow-sm" role="group">
                    <button
                      type="button"
                      className="btn btn-sm btn-outline-primary"
                      onClick={handleThisMonth}
                      style={{
                        borderRadius: '8px 0 0 8px',
                        padding: '5px 12px',
                        fontSize: '13px',
                        fontWeight: '500',
                        borderColor: '#3378FF',
                        color: '#3378FF'
                      }}
                    >
                      This Month
                    </button>
                    <button
                      type="button"
                      className="btn btn-sm btn-outline-primary"
                      onClick={handlePreviousMonth}
                      style={{
                        borderRadius: '0 8px 8px 0',
                        padding: '5px 12px',
                        fontSize: '13px',
                        fontWeight: '500',
                        borderLeft: 'none',
                        borderColor: '#3378FF',
                        color: '#3378FF'
                      }}
                    >
                      Prev Month
                    </button>
                  </div>
                </div>
                
                {/* Date Range */}
                <div className="d-flex align-items-center" style={{gap: '8px'}}>
                  <input
                    type="date"
                    name="startDate"
                    className="form-control form-control-sm shadow-sm"
                    style={{
                      borderRadius: '8px',
                      border: '1px solid #e3e6f0',
                      padding: '5px 12px',
                      fontSize: '14px',
                      minWidth: '140px',
                      backgroundColor: '#fff',
                      transition: 'border-color 0.2s',
                      cursor: 'pointer'
                    }}
                    value={startDate}
                    onChange={(e) => setStartDate(e.target.value)}
                    onFocus={(e) => e.target.style.borderColor = '#3378FF'}
                    onBlur={(e) => e.target.style.borderColor = '#e3e6f0'}
                  />
                  <span className="text-muted" style={{fontSize: '13px', fontWeight: '500'}}>to</span>
                  <input
                    type="date"
                    name="endDate"
                    className="form-control form-control-sm shadow-sm"
                    style={{
                      borderRadius: '8px',
                      border: '1px solid #e3e6f0',
                      padding: '5px 12px',
                      fontSize: '14px',
                      minWidth: '140px',
                      backgroundColor: '#fff',
                      transition: 'border-color 0.2s',
                      cursor: 'pointer'
                    }}
                    value={endDate}
                    onChange={(e) => setEndDate(e.target.value)}
                    onFocus={(e) => e.target.style.borderColor = '#3378FF'}
                    onBlur={(e) => e.target.style.borderColor = '#e3e6f0'}
                  />
                </div>
              </div>
            </Col>
          </Row>
        </Col>

        <Col lg="8" md="12" className="d-flex">
          {isLoading ?
            <Card className="w-100" style={{borderRadius: '12px', border: '1px solid #e5e5e5', minHeight: '400px'}}>
              <Card.Body className='d-flex justify-content-center align-items-center'>
                <div className="spinner-border text-primary" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
              </Card.Body>
            </Card>
            : <Card className="w-100" style={{borderRadius: '15px', border: 'none', boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)', minHeight: '400px', background: '#fff'}}>
              <Card.Body className="p-4 d-flex flex-column">
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <div>
                    <h5 className="font-weight-bold mb-1" style={{color: '#1a202c', fontSize: '18px'}}>Leads Report</h5>
                    <p className="text-muted small mb-0" style={{fontSize: '13px'}}>Daily lead distribution</p>
                  </div>
                  <div className="d-flex align-items-center gap-2">
                    <span className="badge bg-primary d-flex align-items-center gap-1" style={{padding: '6px 12px'}}>
                      <span style={{width: '8px', height: '8px', borderRadius: '50%', background: 'white'}}></span>
                      Leads
                    </span>
                  </div>
                </div>
                <div className="flex-grow-1 d-flex align-items-center">
                  <Chart
                    className="custom-chart w-100"
                    options={chart1.options}
                    series={chart1.series}
                    type="area"
                    height="300"
                  />
                </div>
              </Card.Body>
            </Card>
          }
        </Col>

        <Col lg="4" md="12">
          <div style={{height: '100%', display: 'flex', flexDirection: 'column', gap: '8px'}}>
            <Card style={{borderRadius: '12px', border: 'none', boxShadow: '0 2px 4px rgba(0, 0, 0, 0.06)', height: user?.role === 'admin' ? 'calc((400px - 16px) / 3)' : 'calc((400px - 8px) / 2)', transition: 'transform 0.2s ease, box-shadow 0.2s ease', cursor: 'default'}} className="hover-lift">
              <Card.Body className="d-flex align-items-center py-3">
                <div className="d-flex align-items-center justify-content-between w-100">
                  <div>
                    <p className="mb-1 text-muted small" style={{fontSize: '12px', fontWeight: '500', textTransform: 'uppercase', letterSpacing: '0.5px'}}>New Leads</p>
                    <h3 className="mb-0 font-weight-bold" style={{color: '#1a202c', fontSize: '28px'}}>{formatNumber(totalLeads)}</h3>
                  </div>
                  <div className="rounded-circle p-3" style={{background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', boxShadow: '0 4px 15px rgba(102, 126, 234, 0.4)'}}>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M12 2L2 7L12 12L22 7L12 2Z" stroke="#ffffff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                      <path d="M2 17L12 22L22 17" stroke="#ffffff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                      <path d="M2 12L12 17L22 12" stroke="#ffffff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </div>
                </div>
              </Card.Body>
            </Card>
            <Card style={{borderRadius: '12px', border: 'none', boxShadow: '0 2px 4px rgba(0, 0, 0, 0.06)', height: user?.role === 'admin' ? 'calc((400px - 16px) / 3)' : 'calc((400px - 8px) / 2)', transition: 'transform 0.2s ease, box-shadow 0.2s ease', cursor: 'default'}} className="hover-lift">
              <Card.Body className="d-flex align-items-center py-3">
                <div className="d-flex align-items-center justify-content-between w-100">
                  <div>
                    <p className="mb-1 text-muted small" style={{fontSize: '12px', fontWeight: '500', textTransform: 'uppercase', letterSpacing: '0.5px'}}>
                      {user?.role === 'admin' ? 'Total Users Balance' : 'Current Balance'}
                    </p>
                    <h3 className="mb-0 font-weight-bold" style={{color: '#10b981', fontSize: '28px'}}>
                      {user?.role === 'admin' && totalCreditBalance !== null 
                        ? formatCurrency(totalCreditBalance) 
                        : formatCurrency(user?.credit_balance)}
                    </h3>
                  </div>
                  <div className="rounded-circle p-3" style={{background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)', boxShadow: '0 4px 15px rgba(16, 185, 129, 0.4)'}}>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M12 2V22" stroke="#ffffff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                      <path d="M17 5H9.5C8.57174 5 7.6815 5.36875 7.02513 6.02513C6.36875 6.6815 6 7.57174 6 8.5C6 9.42826 6.36875 10.3185 7.02513 10.9749C7.6815 11.6313 8.57174 12 9.5 12H14.5C15.4283 12 16.3185 12.3687 16.9749 13.0251C17.6313 13.6815 18 14.5717 18 15.5C18 16.4283 17.6313 17.3185 16.9749 17.9749C16.3185 18.6313 15.4283 19 14.5 19H6" stroke="#ffffff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </div>
                </div>
              </Card.Body>
            </Card>
            {user?.role === 'admin' && (
              <Card style={{borderRadius: '12px', border: 'none', boxShadow: '0 2px 4px rgba(0, 0, 0, 0.06)', height: 'calc((400px - 16px) / 3)', transition: 'transform 0.2s ease, box-shadow 0.2s ease', cursor: 'default'}} className="hover-lift">
                <Card.Body className="d-flex align-items-center py-3">
                  <div className="d-flex align-items-center justify-content-between w-100">
                    <div>
                      <p className="mb-1 text-muted small" style={{fontSize: '12px', fontWeight: '500', textTransform: 'uppercase', letterSpacing: '0.5px'}}>EFX Distribution Rate</p>
                      <h3 className="mb-0 font-weight-bold" style={{color: distributionRate >= 80 ? '#10b981' : distributionRate >= 50 ? '#f59e0b' : '#ef4444', fontSize: '28px'}}>
                        {distributionRate !== null ? `${distributionRate}%` : '-%'}
                      </h3>
                    </div>
                    <div className="rounded-circle p-3" style={{background: distributionRate >= 80 ? 'linear-gradient(135deg, #10b981 0%, #059669 100%)' : distributionRate >= 50 ? 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)' : 'linear-gradient(135deg, #ef4444 0%, #dc2626 100%)', boxShadow: '0 4px 15px rgba(0, 0, 0, 0.2)'}}>
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z" stroke="#ffffff" strokeWidth="2"/>
                        <path d="M12 6V12L16 14" stroke="#ffffff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                      </svg>
                    </div>
                  </div>
                </Card.Body>
              </Card>
            )}
          </div>
        </Col>
      </Row>

      {/* Revenue Chart and Commission Row - Admin Only */}
      {user?.role === 'admin' && (
        <Row className="mt-4">
          <Col lg="8">
            <RevenueChart
              categories={categories}
              revenueData={revenueData}
              totalRevenue={totalRevenue}
              isLoading={isLoading}
            />
          </Col>
          <Col lg="4">
            <CommissionCard />
          </Col>
        </Row>
      )}

      {/* Lead Distribution Statistics - Admin Only */}
      {user?.role === 'admin' && (
        <Row className="mt-4">
          <Col md="12">
            <LeadDistributionChart startDate={startDate} endDate={endDate} />
          </Col>
        </Row>
      )}

      {/* Undistributed Leads Section - Admin Only */}
      {user?.role === 'admin' && (
        <Row className="mt-4">
          <Col md="12">
            <UndistributedLeads />
          </Col>
        </Row>
      )}

      {/* Weekly Distribution Rate Chart - Admin Only */}
      {user?.role === 'admin' && (
        <Row className="mt-4">
          <Col lg="12">
            <WeeklyDistributionRate />
          </Col>
        </Row>
      )}
    </Container>
    </>
  );
};

export default Dashbord;
